/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles.module.css'
import photoShape from 'shapes/Photo'

const PhotoPane = ({ className, photo }) => {
  return (
    <section className={cx(className, styles.PhotoPane)}>
      <img src={photo.src} />
    </section>
  )
}

PhotoPane.propTypes = {
  className: PropTypes.string,
  photo: photoShape.single,
}

export default PhotoPane
